import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22PageHeroRef.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../../../public/fonts/fraunces-regular.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../../../../public/fonts/fraunces-600.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22}]}],%22variableName%22:%22heroDisplay%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'heroDisplay', 'heroDisplay Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
